import * as React from 'react';
export const WarningModal = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={112} height={112}>
    <defs>
      <clipPath id="a">
        <path fill="#e8e8e8" d="M2204 728h112v112h-112z" />
      </clipPath>
    </defs>
    <g transform="translate(-2204 -728)">
      <g transform="translate(2204 728.001)">
        <circle cx={56} cy={56} r={56} fill="#fef9f1" />
        <circle
          cx={41.067}
          cy={41.067}
          r={41.067}
          fill="#f2b050"
          data-name="Ellipse"
          transform="translate(14.933 14.933)"
        />
        <circle cx={3.733} cy={3.733} r={3.733} fill="#fff" data-name="Ellipse" transform="translate(52.267 67.2)" />
        <path fill="none" stroke="#fff" strokeLinecap="round" strokeWidth={6} d="M56 37.333v22.4" />
      </g>
    </g>
  </svg>
);
